<div class="radio-group mode-{{mode}}" *ngIf="options && options.length" [class.text-aside]="textAside" [class.grow-items]="growItems">
	<label class="radio-option image-style-{{imageStyle}}" *ngFor="let option of options" [class.selected]="option.value === selectedOption?.value"
		[class.no-flex-grow]="!flexGrow" [ngStyle]="{'flex-basis': flexBaseChild ? flexBaseChild : '100px'}"
		[matTooltip]="option.disabled && option.disabledText ? option.disabledText : ''"
		[matTooltipClass]="mode === 'image' ? 'bb-radio-list-tooltip-image' : ''"
		[class.disabled]="option.disabled"
		[style.--border-color]="borderColor">
		<input type="radio" [name]="id" [(ngModel)]="selectedOptionValue" [value]="option.value"
			(ngModelChange)="onRadioChange(option)" [disabled]="option.disabled" />

		<i *ngIf="mode === 'image' && imageStyle === 'button' && (option.value === selectedOption?.value || option.value === selectedOption)"
			class="fas fa-circle-check"></i>

		<span *ngIf="mode === 'image' && !option.bgAspectRatio" class="image-wrapper" [style.aspect-ratio]="option.imageAspectRatio">
			<img *ngIf="option.imageUrl" class="option-image" [src]="option.imageUrl" alt="" />
			<i *ngIf="option.icon" [ngClass]="(option.iconStyle ? 'fa-' + option.iconStyle : 'fa') + ' fa-xl fa-' + option.icon"></i>
		</span>

		<div *ngIf="mode === 'image' && option.bgAspectRatio" class="ar-wrapper">
			<div class="ar" [style.aspect-ratio]="option.bgAspectRatio" [class.fill-width]="option.bgAspectRatio > 1.8" [class.fill-height]="option.bgAspectRatio <= 1.8"></div>
		</div>

		<span class="text-wrapper">
			<span class="label-text" [class.no-wrap]="noWrap">
				{{ option.label }}
			</span>
			<span *ngIf="option.description" class="label-description">
				{{ option.description }}
			</span>		
		</span>
		<span *ngIf="option.icon && showIcons && mode !== 'image'">
			<i [ngClass]="'fa fa-' + option.icon"></i>
		</span>
	</label>
</div>
